<script setup>
// NOOVI: lista de resultados de busca para Appointments (Atendimentos — fase-29).
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultAppointmentItem from './SearchResultAppointmentItem.vue';

defineProps({
  appointments: {
    type: Array,
    default: () => [],
  },
  query: {
    type: String,
    default: '',
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.APPOINTMENTS')"
    :empty="!appointments.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="appointments.length" class="space-y-3 list-none">
      <li v-for="appointment in appointments" :key="appointment.id">
        <SearchResultAppointmentItem
          :contact-name="appointment.contact && appointment.contact.name"
          :service-name="appointment.service && appointment.service.name"
          :professional-name="
            appointment.professional && appointment.professional.name
          "
          :status="appointment.status"
          :scheduled-at="appointment.scheduledAt"
          :account-id="accountId"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
